import React from "react";
import clsx from "clsx";
import "../style.scss";
import PropTypes from "prop-types";

import { makeStyles } from "@material-ui/core/styles";
import { AttachIcon } from "../../../../Assets";
import { useState } from "react";
import { getBase64, isNull } from "App/utils/helpers";

const useStyles = makeStyles({
  root: {
    border: "1px dashed #D8D8D8",
    padding: "0.5rem 0.5rem",
    borderRadius: "4px",
    display: "flex",
  },
  customLabel: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
  },
  input: {
    opacity: "0",
  },
  error: {
    marginTop: "5px",
    color: "red",
    fontSize: "10px",
    marginLeft: "2px",
  },
});

export default function InputFileCustom(props) {
  const {
    id,
    label,
    initialNameFile,
    name,
    className,
    disabled = false,
    error,
    message,
    convertToBase64 = true,
    setFile,
    ...other
  } = props;

  const classes = useStyles();

  const [nameFile, setNameFile] = useState(label);
  const [temp, setTemp] = useState(null);

  const handleChange = (e) => {
    setNameFile(e.target.files[0].name);
    setFile(e.target.files[0]);
    setTemp(e.target.files[0]);

    if (convertToBase64) {
      getBase64(e.target.files[0], (result) => {
        setFile(result);
      });
    }
  };

  const handleChangeTrash = () => {
    setFile(null);
    setTemp(null);
    setNameFile(null);
  };

  return (
    <>
      <div className={classes.root}>
        <div
          style={{
            flex: "2",
          }}>
          <label htmlFor={id} className={clsx(classes.customLabel, className)}>
            <AttachIcon width='24' height='24' fill='#D8D8D8' />
            {initialNameFile === null ? label : nameFile}
          </label>
        </div>
        {!isNull(temp) && (
          <div
            onClick={handleChangeTrash}
            style={{
              cursor: "pointer",
              padding: "0 1rem",
            }}>
            <i className='fas fa-trash-alt'></i>
          </div>
        )}
      </div>
      {error && <p className={classes.error}> {message} </p>}
      <input
        id={id}
        name={name}
        disabled={disabled}
        type='file'
        className={classes.input}
        onChange={(e) => handleChange(e)}
        {...other}
      />
    </>
  );
}

InputFileCustom.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  error: PropTypes.bool,
  message: PropTypes.string,
  label: PropTypes.string,
  className: PropTypes.string,
};
